module.exports = __webpack_public_path__ + "img/VO.67a65a9a.png";